export default "__VITE_ASSET__e0aOl9cj__"